/* eslint-disable max-len */
import { SvgProps } from './types'

/**
 * Ícone de preenchimento, diferente dos de contorno desta pasta: a cor vai
 * em fill, não em stroke.
 *
 * O viewBox foi apertado na tinta do arquivo original (noun_SpeechBubble_182292.svg),
 * que vinha com folga grande em volta do desenho — sem isso o ícone
 * apareceria bem menor que os vizinhos na mesma fileira.
 */
export const SpeechBubbleDotsIcon = ({ color, className }: SvgProps) => (
  <svg
    width="58.1"
    height="53.1"
    viewBox="17 17.9 58.1 53.1"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g>
      <path d="M46,18c-16,0-29,11.9-29,26.5s1.5,9.7,4.3,13.9l-2.4,9.1c-.2.8,0,1.7.5,2.3.7.9,2,1.3,3.1.9l9-3.4c4.4,2.3,9.4,3.6,14.6,3.6,16,0,29-11.9,29-26.5s-13-26.5-29-26.5ZM46,69c-5,0-9.8-1.2-14-3.6l-.4-.2-9.8,3.7c-.3.1-.6,0-.8-.2,0-.1-.2-.3-.1-.6l2.7-10-.3-.4c-2.8-3.9-4.2-8.5-4.2-13.1,0-13.5,12.1-24.5,27-24.5s27,11,27,24.5-12.1,24.5-27,24.5Z" fill={color} />
      <path d="M34,40c-2.8,0-5,2.2-5,5s2.2,5,5,5,5-2.2,5-5-2.2-5-5-5ZM34,48c-1.7,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3Z" fill={color} />
      <path d="M46,40c-2.8,0-5,2.2-5,5s2.2,5,5,5,5-2.2,5-5-2.2-5-5-5ZM46,48c-1.7,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3Z" fill={color} />
      <path d="M58,40c-2.8,0-5,2.2-5,5s2.2,5,5,5,5-2.2,5-5-2.2-5-5-5ZM58,48c-1.7,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3-1.3,3-3,3Z" fill={color} />
    </g>
  </svg>
)
